export default "__VITE_ASSET__FgypUJRGvu1gMBGMxEKbxw__"